import { render, staticRenderFns } from "./IdDisplay.vue?vue&type=template&id=c90138c8&scoped=true&"
import script from "./IdDisplay.vue?vue&type=script&lang=js&"
export * from "./IdDisplay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c90138c8",
  null
  
)

export default component.exports